import { Component, OnInit, Input, ChangeDetectorRef } from "@angular/core";
import { ProjectsLeadsRowComponent } from "./projects-leads-row/projects-leads-row.component";
import { Lead } from "../../@core/data/lead";
import { NbWindowService, NbWindowState } from "@nebular/theme";
import { LenguageService } from "../../@core/utils/lenguage.service";
import { Router } from "@angular/router";
import { LeadService } from "../../@core/api/lead.service";

@Component({
  selector: "ngx-projects-leads-table",
  templateUrl: "./projects-leads-table.component.html",
  styleUrls: ["./projects-leads-table.component.scss"],
})
export class ProjectsLeadsTableComponent implements OnInit {
  filters: any;
  @Input() type: string;
  @Input() assigned: boolean = false;
  leads: Lead[];
  lastPage: boolean;
  loading: boolean;
  pageNumberShow: number = 1;
  pagination = {
    perPage: 100,
    pageNumber: 0,
  };
  order = {
    field: "timestamp",
    direction: "desc",
  };
  range: any;
  selectedRowId: string = "";
  addFilter: boolean = false;
  dateRange: {
    dateStart: number;
    dateEnd: number;
  };

  constructor(
    private windowService: NbWindowService,
    private router: Router,
    private leadService: LeadService,
    public language: LenguageService
  ) {}

  async ngOnInit() {
    this.getLeads();
  }

  nextPage() {
    if (!this.lastPage && !this.loading) {
      this.pagination.pageNumber++;
      this.getLeads();
      this.pageNumberShow++;
    }
  }

  prevPage() {
    if (this.pagination.pageNumber > 0 && !this.loading) {
      this.pagination.pageNumber--;
      this.getLeads();
      this.pageNumberShow--;
    }
  }

  selectRow(data) {
    console.log(data);
    if (data.select) {
      this.selectedRowId = data.id;
    } else {
      this.selectedRowId = "";
    }
    /* 
        let leads = this.leads;
        this.leads = [];
        this.leads = leads; */
  }

  async getLeads() {
    this.loading = true;
    this.leads = <Lead[]>(
      await this.leadService.getLeads(
        this.pagination,
        this.filters,
        this.order
      )
    );
    this.loading = false;

    if (this.leads.length < this.pagination.perPage) {
      this.lastPage = true;
    } else {
      this.lastPage = false;
    }
  }

 

  rangeChanged() {
    let dateEnd = new Date(this.range.end).getTime() + 24 * 60 * 60 * 1000;
    let dateStart = (new Date(this.range.start).getTime() * 1000) / 1000;
    this.filters.dateRange = { dateStart, dateEnd };
  }

  async removeFilters() {
    this.dateRange = undefined;
    this.filters = undefined;
    this.addFilter = false;
    await this.getLeads();
  }
}
